<!-- 用户列表 -->
<template>
  <div class='content'>
    <el-form ref="form" label-width="auto" align="left" :inline="true">
      <el-form-item label="手机号：">
        <el-input placeholder="输入手机号" @change="getTableList()" v-model="params.mobile"></el-input>
      </el-form-item>
      <el-form-item label="昵称：">
        <el-input placeholder="输入昵称" @change="getTableList()" v-model="params.nickName"></el-input>
      </el-form-item>
      <el-form-item label="用户ID：">
        <el-input placeholder="输入用户ID" @change="getTableList()" v-model="params.userId"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="getTableList()">搜索</el-button>
        <el-button size="small" @click="resetParams();getTableList();">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table 
      :data="tableData"
      class="mt-20"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}">
      <!-- show-overflow-tooltip -->
      <el-table-column label="昵称" prop="nickName"></el-table-column>
      <el-table-column label="用户ID" prop="outUserId"></el-table-column>
      <el-table-column label="手机号" prop="mobile"></el-table-column>
      <el-table-column label="注册时间" prop="createTime"></el-table-column>
      <el-table-column label="最后一次登录时间" prop="lastLoginTime"></el-table-column>
      <el-table-column label="完成任务次数" prop="taskTimes"></el-table-column>
      <el-table-column label="领取奖励次数" prop="rewardTimes"></el-table-column>
      <el-table-column label="任务明细">
        <template slot-scope="scope">
          <el-button 
            type="text" 
            size="small" 
            @click="goTaskDataDetails(scope.row.outUserId)">查看明细</el-button>
        </template>
      </el-table-column>
      <el-table-column label="积分" prop="">
        <template slot-scope="scope">
          <!-- {{ scope.row. }} -->
          <el-button 
            type="text" 
            size="small" 
            @click="viewDetails(scope.row.outUserId)">查看明细</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-row class="mt-15 mr-20 text-right" v-if="total > 0">
      <el-pagination 
        small layout="total,prev,pager, next,sizes,jumper" 
        :page-size="params.pageSize"
        :total="total" 
        :current-page.sync="params.pageNum" 
        :page-sizes="[10 ,20 , 30, 40, 50]"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-row>

    <!-- 积分明细 -->
    <el-dialog title="积分明细" top="20px" width="50%" :visible.sync="dialogVisible"> 
      <div class="flex mb-20">
        <div>昵称：{{ maskData.nickName }}</div>
        <div>用户ID：{{ maskData.userId }}</div>
        <div>
          积分：{{ maskData.point }}
          <el-button 
            type="text" 
            size="small" 
            @click="getUserPointDetail(maskData.userId)">查看明细</el-button>
        </div>
      </div>
      <el-table 
        :data="detailsList"
        class="mt-20"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}">
        <!-- <el-table-column label="网关地址" prop=""></el-table-column> -->
        <el-table-column label="网关账号" prop="netBarAccount"></el-table-column>
        <el-table-column label="积分数" prop="totalPoints"></el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-row class="mt-15 mr-20 text-right" v-if="total > 0">
        <el-pagination 
          small layout="total,prev,pager, next,sizes,jumper" 
          :page-size="paramsPoint.pageSize"
          :total="totalPoint" 
          :current-page.sync="paramsPoint.pageNum" 
          :page-sizes="[10 ,20 , 30, 40, 50]"
          @size-change="handleSizeChangePoint" 
          @current-change="handleCurrentChangePoint">
        </el-pagination>
      </el-row>
    </el-dialog>
  </div>
</template>
 
<script>
  export default {
    data() {
      //这里存放数据
      return {
        time:'',
        params:{
          mobile: '',
          userId: '',
          nickName: '',
          pageNum: 1,
          pageSize: 10
        },
        total: 0,
        tableData:[],
        detailsList:[],
        totalPoint: 0,
        paramsPoint:{
          userId: '',
          pageNum: 1,
          pageSize: 10
        },
        maskData:{
          userId: '',
          nickName: '',
          point: 0,
        },
        dialogVisible: false,
      };
    },
    //方法集合
    methods: {
      /**获取列表数据 */
      getTableList(){
        this.ajax.fetch({
          url: this.apis.userList.get,
          disableLoading: true,
          method: 'post',
          param: this.params,
          successFunc: res=>{
            this.total = res.total;
            this.tableData = res.result;
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      viewDetails(userId){
        this.detailsList = [];
        this.paramsPoint.pageNum = 1;
        this.paramsPoint.pageSize = 10;
        this.paramsPoint.userId = userId;
        let data = this.tableData.filter(i => i.outUserId==userId)[0];
        this.maskData.userId = data.outUserId;
        this.maskData.nickName = data.nickName;
        this.maskData.point = data.totalPoints;
        this.getUserBarPointFun();
        this.dialogVisible = true;
      },
      getUserBarPointFun(){
        this.ajax.fetch({
          url: this.apis.userList.getUserBarPoint,
          disableLoading: true,
          method: 'post',
          param: this.paramsPoint,
          successFunc: res=>{
            this.totalPoint = res.total;
            this.detailsList = res.result;
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      goTaskDataDetails(userId) {
        this.$router.push({path: '/taskDataDetails', query: {userId}});
      },
      getUserPointDetail(userId){
        this.$router.push({path: '/integralDetails', query: {userId}});
      },
      dateChange(value) {
        this.form.startTime = value[0];
        this.form.endTime = value[1];
      },
      resetParams(){
        this.params={
          mobile: '',
          userId: '',
          nickName: '',
          pageNum: 1,
          pageSize: 10
        }
      },
      handleSizeChange(page) {
        this.params.pageSize = page;
        this.getTableList();
      },
      handleCurrentChange(val){
        this.params.pageNum = val;
        this.getTableList();
      },
      handleSizeChangePoint(page) {
        this.paramsPoint.pageSize = page;
        this.getUserBarPointFun();
      },
      handleCurrentChangePoint(val){
        this.paramsPoint.pageNum = val;
        this.getUserBarPointFun();
      },
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.getTableList();
    },
  }
</script>

<style lang='scss' scoped>
  .flex{
    display: flex;
    align-items: center;
    >div{
      margin-right: 10px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/page/userManage/userList/userList.vue